import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=7105640a"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports